export default "__VITE_ASSET__84S_S0v3__"